<template>
  <div>
    <div class="m_flex_row" style="margin:30px">
      搜索关键词(姓名、手机号、身份证)：
      <a-input
        placeholder="请输入搜索关键词："
        @change="nameChange"
        v-model="key"
        style="width:300px;margin-left:20px;margin-right:100px;"
      />

      <a-button type="primary" icon="search" style="margin-right:50px">搜索</a-button>

      <a-button type="primary" icon="plus" @click="goAddProject">创建医生</a-button>
    </div>

    <a-table :columns="columns" :dataSource="data" bordered :pagination="false">

      <template slot="operation" slot-scope="text, record">
        <a-popconfirm
          v-if="!record.is_delete"
          title="确定删除该数据吗?"
          @confirm="() => onDelete(record.key)"
        >
          <a href="javascript:;">删除</a>
        </a-popconfirm>
        <a-popconfirm v-else title="确定将删除的数据找回吗？" @confirm="() => getBack(record.key)">
          <a href="javascript:;">找回</a>
        </a-popconfirm>
        <a-divider type="vertical" />
        <a @click="() => edit(record.key)">编辑</a>
      </template>
    </a-table>
    <div style="text-align:center;margin-top:30px;">
      <a-pagination :total="total" @change="changePage" show-less-items />
    </div>
  </div>
</template>
<script>
import request from "../../utils/request";
const columns = [
  {
    title: "序号",
    dataIndex: "the_id",
    width: "5%"
  },
  {
    title: "姓名",
    dataIndex: "name",
    width: "15%",
  },
  {
    title: "手机号",
    dataIndex: "phone",
    width: "15%",
  },
  {
    title: "身份证",
    dataIndex: "id_code",
    width: "15%",
  },
  {
    title: "是否激活",
    dataIndex: "review",
    width: "7%"
  },
  {
    title: "是否有效",
    dataIndex: "is_delete_text",
    width: "7%"
  },
  {
    title: "创建时间",
    dataIndex: "create_time",
    width: "20%"
  },
  {
    title: "操作",
    width: "20%",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" }
  }
];

export default {
  data() {
    return {
      key: "",
      total: 0,
      current_page: 0,
      data: [],
      columns,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    changePage(page, pageSize) {
      this.current_page = page - 1;
      console.log(page, pageSize, this.current_page);
      this.getData();
    },
    nameChange(e) {
      console.log(this.key, e);
      this.getData();
    },
    goAddProject() {
      this.$router.push({
        path: "/doctor/add"
      });
    },
    getData() {
      request({
        url: "/doctor/all",
        method: "get",
        params: {
          page: this.current_page,
          page_size: 10,
          key: this.key
        }
      }).then(response => {
        console.log("获取到的参数", response.data.data);
        if (response.data.success) {
          const list = response.data.data;
          let i = this.current_page * 10 + 1;

          this.data = list.map(item => {
            item["the_id"] = i;
            i += 1;
            return item;
          });
           console.log("获取到的参数", this.data);
          this.total = response.data.total;
        } else {
          this.$message.error(response.data.msg);
        }
      });
    },
    handleSearch(selectedKeys, confirm) {
      confirm();
      this.searchText = selectedKeys[0];
    },

    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
    onDelete(key) {
      request({
        url: "/doctor/" + key + "/",
        method: "delete",
        params: {}
      }).then(response => {
        console.log("111");
        if (response.data.success) {
          this.getData();
        } else {
          this.$message.error(response.data.msg);
        }
      });
    },
    getBack(key) {
      request({
        url: "/doctor/getback/" + key,
        method: "put",
        params: {}
      }).then(response => {
        this.getData();
      });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(key) {
      this.$router.push({ path: "/doctor/add", query: { the_id: key } });
      // const newData = [...this.data];
      // const target = newData.filter(item => key === item.key)[0];
      // if (target) {
      //   target.editable = true;
      //   this.data = newData;
      // }
    },
    save(key) {
      const newData = [...this.data];
      const newCacheData = [...this.cacheData];
      const target = newData.filter(item => key === item.key)[0];
      const targetCache = newCacheData.filter(item => key === item.key)[0];
      if (target && targetCache) {
        delete target.editable;
        this.data = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
      }
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter(item => key === item.key)[0]
        );
        delete target.editable;
        this.data = newData;
      }
    }
  }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
</style>